import React from 'react';
import { ProductIndicators } from './productIndicators';
import { ItemIdentifier, ItemIndicator } from '../../constants/productObjects';

type ProductNameProps = {
    brandName: string,
    description: string,
    productHREF?: string,
    qty?: number,
    itemIdentifier: ItemIdentifier,
    itemIndicators: ItemIndicator[],
    displayId: string,
    textBold: boolean,
    iconSize?: number,
    onClickProductName?: () => void,
    allSalesFinal?: JSX.Element
}

export const ProductName = ({ ...props }: ProductNameProps) => {
    return (
        <div className="wbm-product-name">
            {props.productHREF ?
                <>
                    <a href={props.productHREF} onClick={props.onClickProductName ? props.onClickProductName : undefined}>
                        <div className="product-description">
                            {props.brandName} {props.description}
                        </div>
                    </a>
                    <div className="product-id">
                        {props.displayId}
                    </div>
                </>
                :
                <React.Fragment>
                    <div className={props.textBold ? "product-description" : "product-description product-description-not-bold"}>
                        {props.brandName} {props.description}
                    </div>
                    <div className="product-id">
                        {props.displayId}
                    </div>
                </React.Fragment>
            }            
            {props.qty ? <div className="product-qty">
                QTY: {props.qty}
            </div> : null}
            <ProductIndicators itemIdentifier={props.itemIdentifier} itemIndicators={props.itemIndicators} iconSize={props.iconSize} />
            {props.allSalesFinal &&
                <>
                    {props.allSalesFinal}
                </>
            }
        </div>
    );
}